import { useMemo, useState } from "react";

import { getTags } from "../contentful";

const promise = getTags();

export default function useTags() {
  const [tags, setTags] = useState([]);

  useMemo(() => {
    promise.then((tags) => {
      setTags(tags);
    });
  }, []);

  return tags;
}
